import React from 'react';
import { Link } from 'gatsby';

import {
  CloseSvg,
  SearchSvg,
} from '../common/svg';

import '../../styles/common/navigation-overlay.scss';

const NavigationOverlay = (props) => (
  <div className={`navigation-overlay ${(props.expanded) ? 'expanded' : ''}`}>
    <button
      className="search-close-button"
      onClick={props.closeOverlayClick}
      tabIndex={0}
    >
      { CloseSvg }
    </button>
    <div className="navigation-panel">
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/essays">Essays</Link></li>
        <li><Link to="/collections">Collections</Link></li>
        <li><Link to="/explore">Explore</Link></li>
        <li><Link to="/shop">Shop</Link></li>
        <li><Link to="/support">Support PDR</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/blog">Blog</Link></li>
      </ul>
      <button
        className="search-launcher"
        onClick={() => {
          props.closeOverlayClick();
          props.launchSearch();
        }}
      >
        { SearchSvg } <span className="label">Search</span>
      </button>
    </div>
  </div>
);

export default NavigationOverlay;